module.exports = __webpack_public_path__ + "static/media/sws-user.4e34ca3e.svg";